import React, { FC, useMemo } from "react";
import { PaneDimensionsContext } from "./PaneDimensionsContext";
import { PaneDimensions } from "./PaneDimensions";

export interface PaneDimensionsProviderProps {
  width: number | undefined;
  height: number | undefined;
  children: React.ReactNode;
}

export const PaneDimensionsProvider: FC<PaneDimensionsProviderProps> = (
  props
) => {
  const value: PaneDimensions | null = useMemo(() => {
    if (props.width === undefined || props.height === undefined) {
      return null;
    }
    return {
      width: props.width,
      height: props.height,
    };
  }, [props.height, props.width]);

  return (
    <PaneDimensionsContext.Provider value={value}>
      {props.children}
    </PaneDimensionsContext.Provider>
  );
};
